export default {
  timeTab: {
    today: '1 NGÀY',
    oneWeek: '5 NGÀY',
    oneMonth: '20 NGÀY',
    yearToDate: 'TỪ ĐẦU NĂM',
  },
  footerText:
    'Giá: x 1,000. Khối lượng: x 1,000. Giá trị: x 1,000,000. Dữ liệu cập nhật cuối ngày (Trước 16:00 GMT+7)',
  treeMapSellTitle: 'Bán %{tradeValue} Tỷ',
  treeMapBuyTitle: 'Mua  %{tradeValue} Tỷ',
  treeMapNetSellTitle: 'Bán ròng %{tradeValue} Tỷ',
  treeMapNetBuyTitle: 'Mua ròng  %{tradeValue} Tỷ',
  tooltipBuyTitle: 'GT Tự doanh Mua ',
  tooltipBuyVolumeTitle: 'KL Tự doanh Mua: ',
  tooltipBuyNetTitle: 'GT Tự doanh Mua Ròng: ',
  tooltipSellTitle: 'GT Tự doanh Bán: ',
  tooltipSellVolumeTitle: 'KL Tự doanh Bán: ',
  tooltipSellNetTitle: 'GT Tự doanh Bán Ròng: ',
  PROPRIETARY_VALUE: 'GT Tự Doanh',
  PROPRIETARY_NET: 'GT Tự Doanh Ròng',

  // tooltipBuyTitle: 'GT Tổ chức trong nước Mua ',
  // tooltipBuyVolumeTitle: 'KL Tổ chức trong nước Mua: ',
  // tooltipBuyNetTitle: 'GT Tổ chức trong nước Mua Ròng: ',
  // tooltipSellTitle: 'GT Tổ chức trong nước Bán: ',
  // tooltipSellVolumeTitle: 'KL Tổ chức trong nước Bán: ',
  // tooltipSellNetTitle: 'GT Tổ chức trong nước Bán Ròng: ',
  // PROPRIETARY_VALUE: 'GT Tổ chức trong nước',
  // PROPRIETARY_NET: 'GT Ròng Tổ chức trong nước ',

  updatedDate: 'Ngày cập nhật: %{date}',

  treeMapTickerBuyTitle: 'Mua %{tradeValue} Tr.',
  treeMapTickerSellTitle: 'Bán %{tradeValue} Tr.',

  treeMapMilNetBuyTitle: 'Mua ròng %{tradeValue} Tr.',
  treeMapMilNetSellTitle: 'Bán ròng %{tradeValue} Tr.',
};
